import { Controller } from 'stimulus';
import dragula from 'dragula';

import { createForm } from 'lib/dom';

export default class extends Controller {
  static values = {
    returnTo: String
  }

  connect() {
    this.dnd = new dragula([ this.element ]).on('drop', li => {
      const children = Array.from(this.element.children);
      const form = createForm(li.dataset.formMethod, li.dataset.formAction, {
        return_to: this.returnToValue, [li.dataset.formField]: children.indexOf(li)
      });

      this.element.appendChild(form);

      form.dispatchEvent(new CustomEvent('submit', { bubbles: true }));
    });
  }

  disconnect() {
    this.dnd.destroy();
  }
}
